import { useState } from "react";
import { Link } from "react-router-dom";

const LINKS = [
  {
    heading: "서비스",
    items: ["서비스 소개", "가격 정책", "파트너십", "팀 챌린지"],
  },
  {
    heading: "학습",
    items: ["AI 챌린지 목록", "커뮤니티", "블로그", "인증 시스템"],
  },
  {
    heading: "지원",
    items: ["고객 지원", "이용 약관", "개인정보 처리방침", "자주 묻는 질문"],
  },
];

export default function FooterSection() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append("email", email);
      const res = await fetch("https://readdy.ai/api/form/d754t5r41deorl02f4i0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
        setEmail("");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#F2F4F6] pt-20 pb-10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-16 mb-16">
          {/* Left */}
          <div className="lg:w-80">
            {/* Logo */}
            <div className="flex items-center gap-2 mb-6">
              <img
                src="https://static.readdy.ai/image/e5c5971dbaa3883665c34cea4172400b/b1c3cef8a5b787f4827004da87a9c36d.png"
                alt="GrowSeo"
                className="h-8 w-auto"
              />
              <span className="font-extrabold text-lg text-[#191F28]">GrowSeo</span>
            </div>

            <h3 className="text-2xl font-black text-[#191F28] leading-normal mb-4">
              GrowSeo와 함께
              <br />
              성장하세요
            </h3>
            <p className="text-sm text-[#191F28]/60 mb-8 leading-[1.9]">
              AI 리터러시 챌린지 소식, 새로운 파티 챌린지 알림을 받아보세요.
            </p>

            {/* Newsletter Form */}
            <form
              data-readdy-form
              id="newsletter-form"
              onSubmit={handleSubmit}
              className="space-y-3"
            >
              {!submitted ? (
                <>
                  <div className="border-b border-[#191F28]/20 pb-2">
                    <label className="text-xs text-[#191F28]/50 block mb-2">이메일 주소</label>
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="your@email.com"
                      className="w-full bg-transparent text-sm text-[#191F28] placeholder-[#191F28]/30 outline-none"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={submitting}
                    className="bg-[#191F28] text-white text-sm font-bold px-8 py-3 rounded-full hover:bg-[#00D873] transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50"
                  >
                    {submitting ? "구독 중..." : "구독하기"}
                  </button>
                </>
              ) : (
                <div className="flex items-center gap-2 text-[#00D873] font-semibold">
                  <i className="ri-check-circle-line text-xl" />
                  <span>구독이 완료됐어요!</span>
                </div>
              )}
            </form>
          </div>

          {/* Right Links */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-10">
            {LINKS.map((col) => (
              <div key={col.heading}>
                <h4 className="text-xs font-bold tracking-widest text-[#191F28]/40 uppercase mb-5">
                  {col.heading}
                </h4>
                <ul className="space-y-4">
                  {col.items.map((item) => (
                    <li key={item}>
                      <a
                        href="#"
                        className="text-sm text-[#191F28] hover:text-[#00D873] transition-colors duration-200 leading-relaxed"
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#191F28]/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#191F28]/40">
            © 2026 GrowSeo. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {["ri-instagram-line", "ri-twitter-x-line", "ri-youtube-line", "ri-kakao-talk-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-8 h-8 flex items-center justify-center text-[#191F28]/40 hover:text-[#00D873] transition-colors cursor-pointer"
              >
                <i className={`${icon} text-lg`} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
